import * as z from 'zod';

import { AudienceOrderTypeSchema } from 'types/api';

export const FilterFormSchema = z.object({
  orderType: z.array(AudienceOrderTypeSchema),
});

export type FilterForm = z.infer<typeof FilterFormSchema>;
